import { connect } from 'react-redux';
import noop from 'lodash/noop';
import compact from 'lodash/compact';

import GroupTop from './GroupTop';

import {
  isForecastView,
  selectGroupWinners,
  selectGroupWinnersForecast
} from '@selectors/matches';
import { isSnapshotView } from '@selectors/location';

// Marcas de acierto de clasificados, calculadas comparando el pronóstico del
// usuario contra los clasificados reales. `realWinners` viene vacío hasta que el
// grupo está decidido, por lo que no se muestran marcas prematuras.
export const assertionsOf = ({ winners, realWinners }) => place => {
  const predictedTeam = winners[place - 1];
  if (!predictedTeam || !realWinners.length) return [];

  return compact([
    predictedTeam === realWinners[place - 1] ? 'group-top' : noop(),
    realWinners.includes(predictedTeam) ? 'team-group' : noop()
  ]);
};

export const mapStateToProps = (state, ownProps) => {
  let group = ownProps.group;

  let winners =
    isSnapshotView(state) || isForecastView(state)
      ? selectGroupWinnersForecast(state)[group]
      : selectGroupWinners(state)[group];

  let [firstTeam, secondTeam] = winners || [];

  let getAssertions = isSnapshotView(state)
    ? assertionsOf({
        winners: winners || [],
        realWinners: selectGroupWinners(state)[group] || []
      })
    : noop;

  return {
    firstTeam,
    secondTeam,
    firstAssertions: getAssertions(1),
    secondAssertions: getAssertions(2)
  };
};

export default connect(mapStateToProps)(GroupTop);
